import React, { useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import appconstant from "../../../themes/appconstant";
import { useSelector } from "react-redux";

const WelnessChart = () => {
  const { wellnessChartData } =
    useSelector((state) => state.dashboardReducer) || {};

  // Prepare chart data
  const chartData = [
    {
      name: "0-20",
      value:
        (wellnessChartData &&
          wellnessChartData?.wellnessIndexResponse?.percentage_0_20) ||
        0,
    },
    {
      name: "20-40",
      value:
        (wellnessChartData &&
          wellnessChartData?.wellnessIndexResponse?.percentage_20_40) ||
        0,
    },
    {
      name: "40-60",
      value:
        (wellnessChartData &&
          wellnessChartData?.wellnessIndexResponse?.percentage_40_60) ||
        0,
    },
    {
      name: "60-80",
      value:
        (wellnessChartData &&
          wellnessChartData?.wellnessIndexResponse?.percentage_60_80) ||
        0,
    },
    {
      name: "80-100",
      value:
        (wellnessChartData &&
          wellnessChartData?.wellnessIndexResponse?.percentage_80_100) ||
        0,
    },
  ].filter((item) => item.value !== 0);

  const defaultChart = [
    {
      name: "0-20",
      value: 0,
    },
    {
      name: "20-40",
      value: 0,
    },
    {
      name: "40-60",
      value: 0,
    },
    {
      name: "60-80",
      value: 0,
    },
    {
      name: "80-100",
      value: 0,
    },
  ];

  const totalAssessments =
    wellnessChartData?.wellnessIndexResponse?.totalAssessments || 0;

  const option = {
    title: {
      text: "Score Distribution",
      left: "center",
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)",
    },
    series: [
      {
        name: "Access From",
        type: "pie",
        radius: "50%",
        data: chartData.length === 0 ? defaultChart : chartData,
        color: [
          "rgba(212, 100, 138, 0.6)",
          "rgba(124, 99, 164, 0.8)",
          "rgba(241, 100, 128, 0.4)",
          "rgba(214, 162, 190, 0.4)",
          "rgba(229, 231, 235, 0.4)",
        ],
        itemStyle: {
          borderRadius: 1,
          borderColor: "#fff",
          borderWidth: 2,
        },
        animation: false,
        label: {
          formatter: function (params) {
            // Safely handle NaN if total is 0
            const percent = isNaN(params.percent)
              ? 0
              : params.percent.toFixed(2);
            return `{b|${params.name}}\n{per|${percent}%}`;
          },
          rich: {
            b: {
              fontWeight: "bold",
            },
            per: {
              color: "#333",
              fontWeight: "bold",
            },
          },
        },
      },
    ],
  };
  return (
    <div>
      <ReactEcharts option={option} />
      <div className="p-4">
        <div className="w-full bg-royalPurple text-purple p-[10px] rounded-[10px] text-center text-xs font-normal ">
          {totalAssessments} {appconstant.memberSubmiited}
        </div>
      </div>
    </div>
  );
};

export default WelnessChart;
